import React from 'react';

const Header = props => <div>WelCome, {process.env.apiUrl}</div>;

export default Header;
